import { sendTrackingEvent } from '../services/service.tracking';
import { state as offerState } from '../store/store.offer';
import { state as offervehicleState } from '../store/store.offer-vehicle';
import { formatReplacementTypes, getVehicleData } from '../utils/utils.tracking';

/**
 * Set to track which offer IDs have already been tracked for certificate loads
 * This prevents duplicate tracking events when the same offer is loaded multiple times
 */
const trackedOfferIds = new Set<string>();

/**
 * Tracks offer certificate load exactly once per offer ID
 */
export const trackOfferCertLoad = () => {
  const { offerId } = offerState || {};

  // Skip if this offer has already been tracked
  if (!offerId || trackedOfferIds.has(offerId)) {
    return;
  }

  // Mark this offer as tracked
  trackedOfferIds.add(offerId);

  const vehicleData = getVehicleData();
  let eventData = {
    ico: { offerId },
    ...vehicleData,
  };

  const voi = {
    catalog: 'kbb',
    condition: formatReplacementTypes(offervehicleState.replacementTypes),
    makeId: offervehicleState.replacementMakeId,
    modelId: offervehicleState.replacementModelId,
    year: `${offervehicleState.replacementVehicleYearMin}-${offervehicleState.replacementVehicleYearMax}`,
  };

  if (offervehicleState.hasReplacement) {
    eventData = { ...eventData, ...{ voi } };
  }

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'impression',
    eventResult: 'ico_thank',
    eventNonInteractive: false,
    eventData,
  });
};

const ineligibleReason = (answerIneligible) => {
  let reason = '';
  const { isSalvage, hasFloodDamage, hasFrameDamage, previouslyCanadian, notActualMileage } = answerIneligible;

  if (isSalvage.value) {
    reason += 'salvage|';
  }
  if (hasFloodDamage.value) {
    reason += 'flood|';
  }
  if (hasFrameDamage.value) {
    reason += 'frame|';
  }
  if (previouslyCanadian.value) {
    reason += 'canadianreg|';
  }
  if (notActualMileage.value) {
    reason += 'mileage|';
  }

  return `cta::get-my-offer-ineligible::${reason.replace(/.$/, '')}`;
};

export const trackOfferIneligible = (answerIneligible) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: ineligibleReason(answerIneligible),
    eventNonInteractive: false,
  });
};

export const trackOfferCertExpiredResubmit = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'submit',
    eventResult: 'resubmit_btn',
    eventNonInteractive: false,
  });
};

export const trackOfferCertificateHeader = (title) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: `cta::certificate_header::${title}`,
    eventNonInteractive: false,
  });
};

export const trackUserScroll = (percentage: string = ''): void => {
  sendTrackingEvent({
    eventAction: 'scroll',
    event: 'analytics_event',
    eventResult: `scroll-milestone::${percentage}`,
    eventNonInteractive: false,
  });
};
